import * as yup from 'yup'
import { createDataSchema } from '../schemaUtils'

export const DEFAULT_CUSTOM_ELEMENT_URL_SERVER =
	'https://static.parastorage.com/services/wix-ui-santa/1.1117.0/assets/CustomElement/wixDefaultCustomElement.js'

export const dataSchema = createDataSchema(
	'CustomElementComponentData',
	yup.object({
		tagName: yup.string().default('wix-default-custom-element'),
		url: yup.string().default(DEFAULT_CUSTOM_ELEMENT_URL_SERVER),
		hostedInCorvid: yup.boolean().default(false),
		initialAttributes: yup.string().default('{}').max(1024),
	})
)
